import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

import Favicon from 'public/icons/new-favicon.svg';
import RightArrow from 'public/icons/green-right-arrow.svg';

const buttonStyle = {
  padding: '6px 10px',
  height: 30,
  backgroundColor: '#12dfc7',
  color: '#323643',
  marginTop: 30,
};

const iconStyle = {
  filter: 'invert(29%) sepia(22%) saturate(453%) hue-rotate(18deg) brightness(10%) contrast(60%)',
};
const faviconStyle = {
  position: 'absolute',
  top: -30,
  right: -60,
  width: 225,
  height: 'auto',
  zIndex: -1,
};

const PurpleCard = ({ title, description, buttonText, handleClick }) => (
  <div onClick={handleClick} className="hover">
    <div
      style={{
        position: 'relative',
        width: 'fit-content',
        padding: 20,
        borderRadius: 10,
        backgroundImage: 'linear-gradient(117deg, #9400ef, #5b00db 99%)',
        zIndex: 1,
        marginBottom: 20,
        overflow: 'hidden',
      }}
    >
      <h2 style={{ color: '#fff', fontSize: 24 }}>{title}</h2>

      <p style={{ color: '#fff' }}>{description}</p>

      <Button variant="contained" endIcon={<RightArrow style={iconStyle} />} style={buttonStyle}>
        {buttonText}
      </Button>

      <Favicon style={faviconStyle} />
    </div>
  </div>
);

PurpleCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
};

PurpleCard.defaultProps = {
  handleClick: () => {},
};

export default PurpleCard;
